<script>
  import ApexCharts from "apexcharts"
  import LoadingScreen from "../../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import ApplicationState from "../../../../Stores/applicationStates"
  import { afterUpdate, onDestroy } from "svelte"

  /**
   * @type {Array} - it contains chart data
   */
  export let chartData

  /**
   * @type {Boolean} - for loading screen Show or hide
   */
  let apiCallBtnDisable = false

  //used for rendering chart
  let chart

  /**
   * @type {HTMLElement} - chart div element
   */
  let chartDiv

  /**
   * @type {Object} - it contains the properties for customizing chart
   */
  let options = {
    chart: {
      redrawOnWindowResize: true,
      height: 500,
      type: "line",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    stroke: {
      curve: "smooth",
      // curve: "straight",
      width: 2,
    },
    dataLabels: {
      enabled: false,

      // style: {
      //   colors: ["#333"],
      // },
    },
    dropShadow: {
      enabled: true,
      top: 0,
      left: 0,
      opacity: 0.2,
    },

    legend: {
      // position: "top",
      // horizontalAlign: "right",
      labels: {
        colors: "#666666",
        useSeriesColors: false,
      },
    },
    series: [
      {
        name: "ISSUED",
        color: "#ff6a00",
      },
      {
        name: "VIEWED",
        color: "#00B2FF",
      },
      {
        name: "VERIFIED",
        color: "#00D515",
      },
      {
        name: "DOWNLOADED",
        color: "#6a359c",
      },
    ],
    xaxis: {
      labels: {
        style: {
          colors: ["#707175"],
        },
      },
      axisBorder: {
        show: false,
        color: "#858585",
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      // show: false,
      logarithmic: false,
      logBase: 2,
      // tickAmount: 100,
      // stepSize: 10,
      // forceNiceScale: true,
      // floating: true,
      axisBorder: {
        show: false,
        color: "#858585",
      },
      labels: {
        show: false,
        style: {
          colors: ["#707175"],
        },
        formatter: function (value) {
          let modifiedValue = Math.log(Math.round(Math.pow(2, value)) - 1) / Math.log(2)
          return value != 0 ? Math.floor(modifiedValue * 100) / 100 : 0
        },
      },
    },
    grid: {
      show: true,
      borderColor: "#ffffff",
      strokeDashArray: 1,
      position: "back",
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
      row: {
        colors: undefined,
        opacity: 0.5,
      },
      column: {
        colors: undefined,
        opacity: 0.5,
      },
    },
    tooltip: {
      y: {
        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
          return value - 1 // Subtract 1 from the actual value, as 1 was added previously.
        },
      },
    },
  }

  afterUpdate(() => {
    if (chartData.length) reAsignChartPoint()
  })

  // while change the chart data
  $: if (chartData.length) reAsignChartPoint($ApplicationState.darkMode, chartData)

  /**
   * @description Assign chart data value to options to render charts
   */
  const reAsignChartPoint = async () => {
    apiCallBtnDisable = true
    let issued = []
    let viewed = []
    let verified = []
    let downloaded = []
    let date = []
    let dateColour = []
    for (let i = 0; i < chartData.length; i++) {
      //adding +1 for converting value into logirthemic value. (log 0 base 2 = undefined) but (log 1 base 2 = 0)

      if (chartData[i].publish >= 6) options.yaxis.logarithmic = true
      if (chartData[i].view >= 6) options.yaxis.logarithmic = true
      if (chartData[i].verify >= 6) options.yaxis.logarithmic = true
      if (chartData[i].download >= 6) options.yaxis.logarithmic = true
      issued.push(chartData[i].publish + 1)
      viewed.push(chartData[i].view + 1)
      verified.push(chartData[i].verify + 1)
      downloaded.push(chartData[i].download + 1)
      let newDate = new Date(chartData[i].date)
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      const month = monthNames[newDate.getMonth()]
      const day = newDate.getDate()
      const formattedDate = `${month} ${day}`
      // let formattedDate = new Date(chartData[i].date).toLocaleDateString("en-US", { month: "short", day: "numeric" })
      date.push(formattedDate)
      dateColour.push("#707175")
    }

    // options.xaxis.axisBorder.color = $ApplicationState.darkMode ? "#3f3f3f" : "#cfcfcf"
    // options.yaxis.axisBorder.color = $ApplicationState.darkMode ? "#8C8C8C" : "#cfcfcf"
    options.grid.borderColor = $ApplicationState.darkMode ? "#2e2e2e" : "#dedede"
    options.grid.borderColor = $ApplicationState.darkMode ? "#2e2e2e" : "#dedede"
    options.tooltip.theme = $ApplicationState.darkMode ? "dark" : "light"
    options.xaxis.categories = date
    options.xaxis.labels.style.colors = dateColour
    options.series[0].data = issued
    options.series[1].data = viewed
    options.series[2].data = verified
    options.series[3].data = downloaded

    createChartElem()
  }

  /**
   * @description create the div for showing chart
   */
  const createChartElem = () => {
    if (chartData.length > 0) {
      if (document.getElementById("chart")) document.getElementById("chart").remove()
      const node = document.createElement("div")
      node.id = "chart"
      if (chartDiv) chartDiv.appendChild(node)
      // setTimeout(loadChart, 200)
      loadChart()
    }
  }

  /**
   * @description For rendering chart
   */
  const loadChart = () => {
    if (document.querySelector("#chart")) {
      if (chart) chart.destroy()
      chart = new ApexCharts(document.querySelector("#chart"), options)
      chart.render()
    }
    apiCallBtnDisable = false
  }

  onDestroy(() => {
    if (chart) chart.destroy()
  })
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- <div id="chart" /> -->
{#if !chartData.length}
  <div class="text-secondary2 select-none rounded-md bg-[#f7f7f7] py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There is no chart data</div>
{:else}
  <div bind:this={chartDiv} class="relative" />
{/if}
{#if apiCallBtnDisable}
  <LoadingScreen msg={"chart data loading"} />
{/if}
